export class SliderInteractionBehavior {
    constructor(sliderUID) {
        this.sliderUID = sliderUID;
        this.behavior = SliderInteractionBehavior.typestatic;
    }
    static is(params) {
        return params.behavior === SliderInteractionBehavior.typestatic;
    }
}
SliderInteractionBehavior.typestatic = "SliderInteraction";
